import { Routes } from '@angular/router';
import { Form } from './form/form';
import { List } from './list/list';

/** Tenant management screens, spread into each add-in's route table. */
export const tenantRoutes: Routes = [
  {
    path: 'tenants',
    data: { hideTenantBar: true },
    children: [
      {
        path: '',
        component: List
      },
      {
        path: 'add',
        component: Form
      },
      {
        path: 'edit/:name',
        component: Form
      }
    ]
  }
];
